<template>
  <div class="new">
    <div class="new-top">
      <div class="new-top__title">新建中转仓库信息</div>
      <div class="new-top__subtitle">(备注：请输入您或您的供应商的仓库信息 (如果不是正式仓库,可理解为货物起运地信息,对应输入即可)</div>
    </div>
    <div class="new-module">
      <div class="new-module-sort">
        <el-radio v-for="item in wasehouseSortArray"
          :key="item.data"
          :label="item.data"
          v-model="transitWasehouse.transitWasehouseSort">{{ item.name }}</el-radio>
      </div>
      <div class="new-module-item">
        <div class="new-module-left">
          <div class="new-module-list" v-for="item in leftInputModule" :key="item.data">
            <div class="new-module-list__name">
              <span class="new-module-list__name--star" v-if="item.isRequired">*</span>
              {{ item.name }}:
            </div>
            <div class="new-module-list__input">
              <template v-if="item.type === 'input'">
                <el-input size="mini" v-model="transitWasehouse[item.data]" :placeholder="item.pla"></el-input>
              </template>
              <template v-else-if="item.type === 'select'">
                <el-select size="mini" v-model="transitWasehouse[item.data]" :placeholder="item.pla"></el-select>
              </template>
            </div>
          </div>
        </div>
        <div class="new-module-right">
          <div class="new-module-list" v-for="item in rightInputModule" :key="item.data">
            <div class="new-module-list__name">
              <span class="new-module-list__name--star" v-if="item.isRequired">*</span>
              {{ item.name }}:
            </div>
            <div class="new-module-list__input">
              <template v-if="item.type === 'input'">
                <el-input size="mini" v-model="transitWasehouse[item.data]" :placeholder="item.pla"></el-input>
              </template>
              <template v-else-if="item.type === 'select'">
                <el-select size="mini" v-model="transitWasehouse[item.data]" :placeholder="item.pla"></el-select>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="new-module-list new-module-list--textarea">
        <div class="new-module-list__name">备注:</div>
        <div class="new-module-list__input">
          <el-input type="textarea" size="mini" resize="none" rows="3"></el-input>
        </div>
      </div>
      <div class="new-module-bottom">
        <div class="new-module-bottom__btn">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import { TransitWarehouseNewModule, TransitWasehouse } from './class'
export default {
  name: 'newWarehouse',
  data(){
    return {
      transitWasehouse: new TransitWasehouse(),
      wasehouseSortArray: TransitWarehouseNewModule.NEWSORTARRAY(),
      leftInputModule: TransitWarehouseNewModule.NEWLEFTINPUTMODULE(),
      rightInputModule: TransitWarehouseNewModule.NEWRIGHTINPUTMODULE()
    }
  }
}
</script>

<style lang="scss" scoped>
.new{
  width: 1000px;
  &-top{
    display: flex;
    align-items: end;
    border-bottom: 1px solid black;
    margin: 5px 20px;
    padding: 5px;
    &__title{
      font-weight: bold;
      color: black;
      font-size: 16px;
    }
    &__subtitle{
      font-size: 12px;
      color: #fca605;
      margin-left: 5px;
    }
  }
  &-module{
    margin: 5px 20px;
    &-item{
      display: flex;
      justify-content: space-between;
      margin-right: 150px;
    }
    &-list{
      display: flex;
      align-items: center;
      margin: 10px;
      ::v-deep{
        .el-input__inner{
          width: 250px;
        }
      }
      &__name{
        width: 120px;
        margin-right: 8px;
        text-align: end;
        &--star{
          color: red;
        }
      }
      &--textarea{
        align-items: start;
        .new-module-list__name{
          margin-top: 5px;
        }
        ::v-deep{
          .el-textarea__inner{
            width: 650px;
            border-radius: 0;
          }
        }
      }
    }
    &-bottom{
      display: flex;
      justify-content: end;
      margin-right: 150px;
      &__btn{
        padding: 6px 20px;
        background: #00a0c7;
        color: white;
        margin-left: 5px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
  }
}
</style>
